import { ExportCsvOneOnOnesDataDocument } from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { downloadBlob } from 'modules/core/lib/download'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

export function useDownloadOneOnOnesData() {
  const [exportCsvOneOnOnesData, { loading }] = useMutation(ExportCsvOneOnOnesDataDocument, {
    extractorFn: (data) => data.oneOnOnesMutations.exportCsvOneononesExport,
  })

  const downloadData = async () => {
    const result = await exportCsvOneOnOnesData({
      variables: {},
    })

    const handled = handleResult(result, () => {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('one_on_ones.export.error'),
      })
    })

    if (handled.success && handled.data.export) {
      const { csvContent, filename } = handled.data.export

      // Create a blob from the CSV content
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })

      // Use the filename from the response or provide a default
      const downloadFilename = filename || 'one_on_ones_export.csv'

      downloadBlob(blob, downloadFilename)

      app.setFlash({
        type: 'correct',
        message: i18n.t('one_on_ones.export.success'),
      })
    }
  }

  return {
    downloadData,
    loading,
  }
}
